<!--  -->
<template>
  <div class="agreement_c">
    <p class="main_synopsis" style="font-weight: 600">
      您（即授权人）正在使用【北京神州邦邦技术服务有限公司】（以下称“业务办理机构”）为您提供的【神州邦邦APP】（以下称“业务办理机构应用”），如您需使用【账号注册、报名接单、服务实施前打卡签到、服务结交付客户验收、费用提现】，您需按照业务办理机构的要求完成实名认证。
    </p>
    <p class="main_synopsis" style="font-weight: 600">
      受业务办理机构之委托，北京百度网讯科技有限公司（以下简称“百度”）将为您提供实名认证核验服务（以下简称“本服务”），具体以您在业务办理机构应用相关页面选择的为准。为了保障您的合法权益，请您务必事先审慎阅读、充分理解授权书条款内容。如您不同意本授权书，请勿使用本服务。
    </p>
    <div class="main_item">
      <ul class="content_wrap1">
        <li>
          <p>
            在您点击同意本授权书后，即表示您已详细阅读本授权书条款，您同意授权百度收集您的如下信息，并分享给为本服务提供必要技术支持的身份认证服务商及业务办理机构（以下统称“被授权人”），以便被授权人处理您的相关信息，完成身份认证核验服务。
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                实名认证（包含人脸实名认证、人脸比对）服务：获取并使用您的姓名、身份证号码、人脸照片及视频信息，请求权威数据源进行信息核验，以便实现身份信息的比对。同时，为了确认您在进行认证时是否处于可信环境，识别和排除恶意请求、维护服务安全，还将获取并使用您的设备信息、浏览器信息、网络信息和操作记录信息。
              </p>
            </li>
            <li>
              <p>
                身份证识别服务：获取并使用您的身份证照片信息、操作记录信息，通过OCR技术提取证件上的相关信息。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            第1条所述信息是完成实名认证核验服务所必须的信息，如您拒绝提供的，被授权人将无法为您提供本服务，但不影响业务办理机构为您提供其他服务。如您实名认证核验失败，请确保您已经按照要求正确使用本服务，或者向业务办理机构咨询其他办理渠道。在遵守相关法律法规及最小必要原则的前提下，基于业务办理机构为您提供服务之需要，百度可能会向业务办理机构提供实名认证核验服务记录以供查询。您在此同意授权百度将依据第1条收集的您的个人信息分享给业务办理机构，以便实现本条所述目的。
          </p>
        </li>
        <li>
          <p>
            百度仅在为实现本服务所必要的最短时间内保存您的个人信息。为了保障您的个人信息安全，百度会在现有技术水平下采取合理必要的措施来保护您的个人信息，采取物理、技术等安全措施来降低丢失、误用、非授权访问、披露和更改的风险。
          </p>
        </li>
        <li>
          <p>
            如您希望访问、撤回授权、修改、删除您的个人信息，您可以向业务办理机构提出需求，并提供必要的身份证明。
          </p>
        </li>
        <li>
          <p>
            授权人声明：本授权书是您向被授权人做出的单方承诺，效力具有独立性。若您与被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本授权书签订地（即中国北京市海淀区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决等，适用中华人民共和国大陆地区法律（仅为本授权书目的，不含港澳台地区法律），不包括冲突法。
          </p>
        </li>
        <li>
          <p>
            您确认，已理解本授权书所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿作出上述授权，本授权书是您真实的意思表示，您同意承担相关责任及后果。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>